window.renovaSessaoAtivas = function (url,sessaoAplicativo) {
    // Vanilla
    var httpRequest = new XMLHttpRequest()
    httpRequest.onreadystatechange = function (data) {
        // code
        // console.log("SessaoAplicativo Renovada");
    }
    url += "/api/seguranca/renovarSessaoAplicativo?";
    url += "sessaoaplicativo="+sessaoAplicativo;
    url += "&" + new Date().getTime();
    httpRequest.open('GET', url)
    httpRequest.send()
}